/** Data attribute key for which the value is DragSubject's type */
export const DATA_ATTRIBUTE_DRAG_TYPE = 'data-drag-type';
/** Data attribute key for which the value is the ID of what is being dragged */
export const DATA_ATTRIBUTE_DRAG_ID = 'data-drag-id';
